import Metadata from 'shared/components/Metadata'
import { Fragment } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import { trackSegmentCustomEvent } from 'shared/services/analytics/segment'
import Quiz from 'views/find-art/components/Quiz'

const FindArtPage = () => {
  useEffectOnce(() => {
    trackSegmentCustomEvent('find_art_quiz_started')
  })

  return (
    <Fragment>
      <Metadata title="Find Art" description="Looking for art?" url="/find-art" />
      {/* content */}
      <div className="flex min-h-screen w-full flex-col justify-center py-[100px] lg:py-[120px]">
        <Quiz />
      </div>
    </Fragment>
  )
}

export default FindArtPage
